import React from 'react'
import classNames from 'classnames'
import {
  labels as formLabels,
  getAddressFieldLabel,
} from '../../constants/form'

/**
 * Custom Sub Questions Display Component
 * Displays sub-questions for object type questions
 */
const SubQuestionsDisplay = ({
  label,
  subAnswers,
  isEditable = false,
  onFieldChange,
  currentObjectData = {},
  isRequired = false,
  validationErrors = [],
  questionDefinition = null,
  links = [],
}) => {
  // Show all sub-answers regardless of edit mode
  const validSubAnswers = subAnswers || []

  // Don't render if no sub-answers at all
  if (validSubAnswers.length === 0) {
    return null
  }

  const renderLabel = (question, isSubRequired = false) => {
    if (!question) return ''
    const labelText =
      getAddressFieldLabel(question) || formLabels[question] || question
    // Show asterisk (*) when editing and question is required
    if (isEditable && isSubRequired) {
      return (
        <div className='d-flex align-items-center'>
          <span>{labelText}</span>
          <span className='required-question line-height-none mt-1 ms-1'>
            *
          </span>
        </div>
      )
    }
    return labelText
  }

  return (
    <div className='mb-4'>
      <label className='s10a order-0 mb-12px'>
        {renderLabel(label, isRequired, links)}
      </label>
      <div
        style={{
          border: '1px solid #000000',
          borderRadius: '5px',
          padding: '16px',
        }}>
        {validSubAnswers.map((subAnswer, index) => {
          // Get the current value from editable data or fall back to original
          const subKey = subAnswer.subQuestionId
          const currentValue =
            subKey in currentObjectData
              ? currentObjectData[subKey]
              : (Array.isArray(subAnswer.answer)
                  ? subAnswer.answer[0]
                  : subAnswer.answer) || ''

          // Determine if the sub-question is required based on the main question definition
          const isSubQuestionRequired =
            isRequired && questionDefinition?.answerType === 'object'

          return (
            <div
              key={index}
              className='mb-3'
              style={{
                borderBottom:
                  index < validSubAnswers.length - 1
                    ? '1px solid #e9ecef'
                    : 'none',
                paddingBottom:
                  index < validSubAnswers.length - 1 ? '12px' : '0',
              }}>
              <label className='s10a order-0 mb-12px'>
                {renderLabel(subAnswer.subQuestion, isSubQuestionRequired, [])}
              </label>
              {isEditable ? (
                <input
                  className={classNames('form-control', {
                    'is-invalid':
                      isEditable &&
                      isSubQuestionRequired &&
                      (!currentValue || currentValue.trim() === ''),
                  })}
                  value={currentValue}
                  autoComplete='off'
                  onChange={(e) => {
                    if (onFieldChange) {
                      onFieldChange(subKey, e.target.value)
                    }
                  }}
                />
              ) : (
                <div className='sub-question-value'>
                  <span>{currentValue}</span>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SubQuestionsDisplay
